import { configData } from "./configData";
import { mapGetters } from "vuex";

export const submitData = {
  mixins: [configData],
  computed: {
    ...mapGetters({
      ticketData: 'tenants/ticketTypes/ticketData'
    })
  },
  methods: {
    onSubmit(event) {
      if (!this.validateData()) {
        event.preventDefault()
        return
      }
      const itemData = this.collectData()
      if (!itemData.id) {
        this.storeData(itemData)
      } else {
        this.updateItem(itemData)
      }
    },
    collectData() {
      let typeData = {
        id: this.ticketData.id,
        kiosk: !this.ticketData.kioskId ? this.kioskId : this.ticketData.kioskId,
        name: this.ticketData.name,
        description: this.ticketData.description,
        availability: this.ticketData.available_amount,
        pricing_rule: {
          entries: this.ticketData.entries,
          unit_price: this.ticketData.unit_price,
          type: this.ticketData.price_rule_type,
        },
        id_code_enabled: this.ticketData.id_code_enabled,
        icon: this.ticketData.icon
      }

      if (this.ticketData.price_rule_type === this.PICKER) {
        typeData.pricing_rule['unit_price'] = this.ticketData.unit_price
        typeData.pricing_rule['unit_type'] = this.ticketData.unit_type
      } else if (this.ticketData.price_rule_type === this.FIXED) {
        typeData.pricing_rule['rules'] = this.ticketData.time_cost
      }

      return typeData
    },
    validateData() {
      const defaultLang = process.env.DEFAULT_LANGUAGE;
      let isValid = true;
      if (!this.ticketData.name[defaultLang]) {
        this.$store.dispatch('tenants/ticketTypes/addError', { field: 'name' })
        console.log('not validated default name')
        isValid = false
      }
      if (!this.ticketData.price_rule_type) {
        this.$store.dispatch('tenants/ticketTypes/addError', { field: 'price_rule_type' })
        console.log('not validated price_rule_type')
        isValid = false
      }
      if (this.ticketData.available_amount === 0) {
        this.$store.dispatch('tenants/ticketTypes/addError', { field: 'available_amount' })
        console.log('not validated available_amount')
        isValid = false
      }
      if (this.ticketData.price_rule_type === this.PICKER) {
        if (!this.ticketData.unit_price) {
          this.$store.dispatch('tenants/ticketTypes/addError', { field: 'unit_price' })
          console.log('not validated unit_price')
          isValid = false
        }
        if (!this.ticketData.unit_type) {
          this.$store.dispatch('tenants/ticketTypes/addError', { field: 'unit_type' })
          console.log('not validated unit_type')
          isValid = false
        }
      } else if (this.ticketData.price_rule_type === this.FIXED) {
        if (!this.ticketData.time_cost) {
          this.$store.dispatch('tenants/ticketTypes/addError', { field: 'time_cost' })
          console.log('not validated time_cost')
          isValid = false
        }
      } else if (this.ticketData.price_rule_type === this.FIXED_ENTRY) {
        if (!this.ticketData.entries) {
          this.$store.dispatch('tenants/ticketTypes/addError', { field: 'entries' })
          console.log('not validated entries')
          isValid = false
        }
        if (!this.ticketData.unit_price) {
          this.$store.dispatch('tenants/ticketTypes/addError', { field: 'unit_price' })
          console.log('not validated unit_price')
          isValid = false
        }
      }
      return isValid
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tenants/ticket-types/mixins/submitData.js